module.exports = __webpack_public_path__ + "img/light-wood-queen.2db80646.svg";